import { useQuery, type QueryKey, type UseQueryOptions } from '@tanstack/react-query';
import { useApiClient } from './client';

/**
 * Bridge between useApiClient and TanStack Query.
 * Provides automatic caching, deduplication, and stale-while-revalidate.
 */
export function useApiQuery<T>(
  key: QueryKey,
  endpoint: string,
  options?: Omit<UseQueryOptions<T, Error>, 'queryKey' | 'queryFn'>
) {
  const api = useApiClient();

  return useQuery<T, Error>({
    queryKey: key,
    queryFn: () => api.get<T>(endpoint),
    enabled: api.isReady && (options?.enabled !== false),
    ...options,
  });
}
